import React, { MutableRefObject, useEffect, useRef, useState } from 'react'

import { Card, CheckBox, Col, Grid, Input, Line, Row, Text } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { buildSetSize, getItemSize, ReportsRow } from 'components/ReportsRow'
import { useWindowResize } from 'hooks'
import { VariableSizeList as List } from 'react-window'
import { FORMAT, SPACING } from 'utils'
import { TypesReports } from 'utils/types'

import { IInputFields, ListTypes } from '../ReportsBlock'
import { ContainerCard } from './ReportsCard'
import { useLoading, useModal, useToggle } from 'hooks'

export interface ICardFilters {
  centros: TypesReports[]
  fornecedores: TypesReports[]
  contratos: TypesReports[]
  subFornecedores: TypesReports[]
  empresas: TypesReports[]
  empresa: string | undefined
  contrato: string | undefined
  centro: string | undefined
  subcontratada: string | undefined
  fornecedor: string | undefined
  getData: () => void
  handleChangeItem: (
    checked: boolean,
    grid: 'fornecedor' | 'empresa' | 'centro' | 'subFornecedores' | 'contrato',
    id: number
  ) => void
  checkAll: (
    actionType: 'add' | 'remove' | 'checkAll' | 'unCheckAll',
    grid: 'fornecedor' | 'empresa' | 'centro' | 'subFornecedores' | 'contrato',
    id?: number
  ) => void
  handleChangeInput: (value: string, t: ListTypes) => void
  isCheckAllFornecedor: boolean;
  setIsCheckAllFornecedor: (checked: boolean) => void;

  //onCheckAllChange: (checked: boolean) => void;
  isCheckAll: boolean;
  checkedSelecionado: (checked: boolean) => void;
  // fields?: IInputFields;
  // setFields?: React.Dispatch<React.SetStateAction<IInputFields>>;
}

interface WindowingReport {
  sizeMap: MutableRefObject<{}>
  reference: MutableRefObject<any>
}

const CardFiltersGrid: React.FC<ICardFilters> = ({
  centros,
  fornecedores,
  empresas,
  contratos,
  centro,
  empresa,
  subcontratada,
  contrato,
  fornecedor,
  subFornecedores,
  getData,
  handleChangeItem,
  checkAll,
  handleChangeInput,
  isCheckAllFornecedor,
  setIsCheckAllFornecedor,
  checkedSelecionado,
  // fields,
  // setFields
}) => {

  const [windowWidth] = useWindowResize()

  const [selectedFornecedoresCount, setSelectedFornecedoresCount] = useState(0);
  const [filteredContratos, setFilteredContratos] = useState<TypesReports[]>(contratos);
  const [checkedAllContratos, setCheckedAllContratos] = useState(false);

  const fornecedoresWindowing: WindowingReport = {
    reference: useRef(null),
    sizeMap: useRef({})
  }
  const fornecedoresSetSize = buildSetSize(
    fornecedoresWindowing.sizeMap,
    fornecedoresWindowing.reference
  )

  const contratosWindowing: WindowingReport = {
    reference: useRef(null),
    sizeMap: useRef({})
  }
  const contratosSetSize = buildSetSize(
    contratosWindowing.sizeMap,
    contratosWindowing.reference
  )

  const subFornecedoresWindowing: WindowingReport = {
    reference: useRef(null),
    sizeMap: useRef({})
  }
  const subFornecedoresSetSize = buildSetSize(
    subFornecedoresWindowing.sizeMap,
    subFornecedoresWindowing.reference
  )

  const empresasWindowing: WindowingReport = {
    reference: useRef(null),
    sizeMap: useRef({})
  }
  const empresasSetSize = buildSetSize(
    empresasWindowing.sizeMap,
    empresasWindowing.reference
  )

  const centrosWindowing: WindowingReport = {
    reference: useRef(null),
    sizeMap: useRef({})
  }
  const centrosSetSize = buildSetSize(
    empresasWindowing.sizeMap,
    empresasWindowing.reference
  )
  const { showModal } = useModal()
  const handleFornecedorChange = (checked: boolean, id: number) => {
    if (checked && selectedFornecedoresCount >= 2) {
      //alert('Você não pode selecionar mais de 30 fornecedores');
      showModal({
        hideButtonCancel: true,
        message: 'Desculpe, mas você não pode selecionar mais de 30 fornecedores em uma consulta. Caso queira filtrar por todos os fornecedores selecione a opção "Marcar Todos".',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      return;
    }
    handleChangeItem(checked, 'fornecedor', id)
    setSelectedFornecedoresCount((prevCount) =>
      checked ? prevCount + 1 : prevCount - 1
    )
    checkedSelecionado(false)
  }
  useEffect(() => {
    if (checkedAllContratos && selectedFornecedoresCount > 0) {
      setFilteredContratos(contratos.filter(contrato => contrato.flChecked));
    }
    else setFilteredContratos(contratos);
  }, [isCheckAllFornecedor, contratos, checkedAllContratos])

  return (
    <>
      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Input
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
          value={contrato}
          label="Contrato"
          placeholder="Nº"
          onChange={(e) => handleChangeInput(e.target.value, 'contratos')}
        />
        <Input
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          value={fornecedor}
          width="316px"
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          onChange={(e) => handleChangeInput(e.target.value, 'fornecedor')}
        />
      </Grid>

      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Col>
          <CheckBox
            label="Marcar Todos"
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                checkAll('checkAll', 'contrato');
              } else {
                checkAll('unCheckAll', 'contrato');
              }
              setIsCheckAllFornecedor(isChecked);
              setCheckedAllContratos(isChecked);
              checkedSelecionado(isChecked);
            }}
            //setIsCheckAllFornecedor(isChecked);
            disabled={contratos?.length === 0}
            marginBottom={SPACING.spacing10}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />

            <List
              itemCount={filteredContratos.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(contratosWindowing.sizeMap, index)
              }
              ref={contratosWindowing.reference}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <div style={style} key={filteredContratos[index].id}>
                  <ReportsRow
                    index={index}
                    windowWidth={windowWidth}
                    setSize={contratosSetSize}
                  >
                    <Row key={filteredContratos[index].id}>
                      <CheckBox
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          handleChangeItem(
                            e.target.checked,
                            'contrato',
                            filteredContratos[index].id
                          )
                          checkedSelecionado(isChecked)
                        }}
                        checked={filteredContratos[index].flChecked}
                        label={filteredContratos[index].name}
                      />
                    </Row>
                  </ReportsRow>
                </div>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            label="Marcar Todos"
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                checkAll('checkAll', 'fornecedor');
              } else {
                checkAll('unCheckAll', 'fornecedor');
              }
              setIsCheckAllFornecedor(isChecked);
              checkedSelecionado(isChecked);
            }}
            disabled={fornecedores?.length === 0}
            marginBottom={SPACING.spacing10}
          />

          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />

            <List
              itemCount={fornecedores.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(fornecedoresWindowing.sizeMap, index)
              }
              ref={fornecedoresWindowing.reference}
              height={300}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <div style={style} key={fornecedores[index].id}>
                  <ReportsRow
                    index={index}
                    windowWidth={windowWidth}
                    setSize={fornecedoresSetSize}
                  >
                    <Row key={fornecedores[index].id}>
                      <CheckBox
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          handleFornecedorChange(
                            e.target.checked,
                            fornecedores[index].id
                          )
                          checkedSelecionado(isChecked)
                        }}
                        checked={fornecedores[index].flChecked}
                        label={fornecedores[index].name + ' - ' + FORMAT.formatCdDocto(fornecedores[index].cdDocto)}
                      />
                    </Row>
                  </ReportsRow>
                </div>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
      <Grid
        gridCols="1fr 1fr 1fr"
        gridGap="1rem"
        margin="1rem 0 0 0"
        alignItems="center"
      >
        <Input
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
          label="Empresa"
          value={empresa}
          placeholder="Nome da Empresa"
          onChange={(e) => handleChangeInput(e.target.value, 'empresas')}
        />

        <Input
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
          label="Centro"
          value={centro}
          placeholder="Nome do Centro"
          onChange={(e) => handleChangeInput(e.target.value, 'centros')}
        />

        <Input
          inputIcon={<MagnifyingGlassIcon />}
          onClickIcon={getData}
          width="316px"
          label="Subcontratadas dos Fornecedores"
          value={subcontratada}
          placeholder="Nome da Subcontratada"
          onChange={(e) => handleChangeInput(e.target.value, 'subFornecedores')}
        />
      </Grid>
      <Grid gridCols="1fr 1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Col>
          <CheckBox
            label="Marcar Todos"
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                checkAll('checkAll', 'empresa');
              } else {
                checkAll('unCheckAll', 'empresa');
              }
              setIsCheckAllFornecedor(isChecked);
              checkedSelecionado(isChecked);
            }}
            disabled={empresas?.length === 0}
            marginBottom={SPACING.spacing10}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />

            <List
              itemCount={empresas.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(empresasWindowing.sizeMap, index)
              }
              ref={empresasWindowing.reference}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <div style={style} key={empresas[index].id}>
                  <ReportsRow
                    index={index}
                    windowWidth={windowWidth}
                    setSize={empresasSetSize}
                  >
                    <Row key={empresas[index].id}>
                      <CheckBox
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          handleChangeItem(
                            e.target.checked,
                            'empresa',
                            empresas[index].id
                          )
                          checkedSelecionado(true)
                        }}
                        checked={empresas[index].flChecked}
                        label={empresas[index].name}
                      />
                    </Row>
                  </ReportsRow>
                </div>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            label="Marcar Todos"
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                checkAll('checkAll', 'centro');
              } else {
                checkAll('unCheckAll', 'centro');
              }
              setIsCheckAllFornecedor(isChecked);
              checkedSelecionado(isChecked);
            }}
            disabled={centros?.length === 0}
            marginBottom={SPACING.spacing10}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />

            <List
              itemCount={centros.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(centrosWindowing.sizeMap, index)
              }
              ref={centrosWindowing.reference}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <div style={style} key={centros[index].id}>
                  <ReportsRow
                    index={index}
                    windowWidth={windowWidth}
                    setSize={centrosSetSize}
                  >
                    <Row key={centros[index].id}>
                      <CheckBox
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          handleChangeItem(
                            e.target.checked,
                            'centro',
                            centros[index].id
                          )
                          checkedSelecionado(isChecked)
                        }}
                        checked={centros[index].flChecked}
                        label={centros[index].name}
                      />
                    </Row>
                  </ReportsRow>
                </div>
              )}
            </List>
          </Card>
        </Col>
        <Col>
          <CheckBox
            label="Marcar Todos"
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                checkAll('checkAll', 'subFornecedores');
              } else {
                checkAll('unCheckAll', 'subFornecedores');
              }
              setIsCheckAllFornecedor(isChecked);
              checkedSelecionado(isChecked);
            }}
            disabled={subFornecedores?.length === 0}
            marginBottom={SPACING.spacing10}
          />
          <Card
            boxShadow="0px 0px 15px rgba(0, 0, 0, 0.25)"
            borderRadius="10px 10px"
          >
            <Line />

            <List
              itemCount={subFornecedores.length}
              estimatedItemSize={30}
              itemSize={(index: number) =>
                getItemSize(subFornecedoresWindowing.sizeMap, index)
              }
              ref={subFornecedoresWindowing.reference}
              height={180}
              width="100%"
              useIsScrolling
            >
              {({ index, style }) => (
                <div style={style} key={subFornecedores[index].id}>
                  <ReportsRow
                    index={index}
                    windowWidth={windowWidth}
                    setSize={subFornecedoresSetSize}
                  >
                    <Row key={subFornecedores[index].id}>
                      <CheckBox
                        onChange={(e) => {
                          const isChecked = e.target.checked
                          handleChangeItem(
                            e.target.checked,
                            'subFornecedores',
                            subFornecedores[index].id
                          )
                          checkedSelecionado(isChecked)
                        }}
                        checked={subFornecedores[index].flChecked}
                        label={subFornecedores[index].name}
                      />
                    </Row>
                  </ReportsRow>
                </div>
              )}
            </List>
          </Card>
        </Col>
      </Grid>
    </>
  )
}

export default CardFiltersGrid
